import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type {
	FindAllLogQuery,
	LogPaginatedResponse,
} from '../../../../../apps/admin/src/features/logs/types/log.types';

export const useGetLogs = ({
	page = 1,
	limit = 10,
	type,
	status,
	authorId,
	startDate,
	endDate,
	search,
	enabled = true,
}: FindAllLogQuery = {}) => {
	const query = useQuery<LogPaginatedResponse>({
		queryKey: ['logs', page, limit, type, status, authorId, startDate, endDate, search],
		enabled,
		placeholderData: (previousData) => previousData,
		queryFn: async () => {
			try {
				const { data } = await api.get<LogPaginatedResponse>('/management/log/findAll', {
					params: {
						page,
						limit,
						...(type ? { type } : {}),
						...(status ? { status } : {}),
						...(authorId ? { authorId } : {}),
						...(startDate ? { startDate } : {}),
						...(endDate ? { endDate } : {}),
						...(search ? { search } : {}),
					},
				});

				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar logs.');
			}
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? {
					totalDocs: query.data.totalDocs,
					totalPages: query.data.totalPages,
					page: query.data.page,
					limit: query.data.limit,
					hasPrevPage: query.data.hasPrevPage,
					hasNextPage: query.data.hasNextPage,
					prevPage: query.data.prevPage,
					nextPage: query.data.nextPage,
				}
			: null,
	};
};
